import React from "react";
import AnamneseIcon from "../Assets/work/form.png";
import AvaliacaoIcon from "../Assets/work/body_exam.png";
import PlanejamentoIcon from "../Assets/work/training_routine.png";
import AcompanhamentoIcon from "../Assets/work/followup.png";
import SuporteIcon from "../Assets/work/support.png";
import VideoIcon from "../Assets/work/videocall.png";
import "./Work.css";

const Work = () => {
  const stepsData = [
    { image: AnamneseIcon, title: "Anamnese", text: "Questionário detalhado + fotos iniciais para entender seu ponto de partida." },
    { image: AvaliacaoIcon, title: "Avaliação completa", text: "Análise física e funcional para identificar necessidades e limitações." },
    { image: PlanejamentoIcon, title: "Planejamento personalizado", text: "Treino e sugestão alimentar." },
    { image: AcompanhamentoIcon, title: "Acompanhamento constante", text: "Feedback e ajustes semanais para garantir evolução contínua." },
    { image: SuporteIcon, title: "Suporte direto", text: "Contato via WhatsApp para alinhamentos." },
    { image: VideoIcon, title: "Videoconferência", text: "Videoconferência periódica com alunos." },
  ];

  return (
    <section className="work" id="work" data-animate="fade-up" data-delay="200">

      <div className="work-header">
        <h1 className="work-title">Como funciona a consultoria</h1>
        <p className="work-description">
          Passo a passo simples e objetivo para alcançar seus resultados com acompanhamento profissional.
        </p>
      </div>

      <div className="work-grid">
        {stepsData.map((step) => (
          <article className="work-card" key={step.title}>
            <div className="work-card-image">
              <img src={step.image} alt="" aria-hidden="true" />
            </div>
            <h2 className="work-card-title">{step.title}</h2>
            <p className="work-card-text">{step.text}</p>
          </article>
        ))}
      </div>

    </section>
  );
};

export default Work;